
const theme = {
  palette: {
    typography: {
      fontFamily: "sans-serif",
    },
  
    primary: {
      main: "#16aa9d",
      contrastText: "#fff",
    },

    secondary: {
      main: "#004d5c",
      contrastText: "#fff",
    },

    default: {
      main: "#f6f8f9",
      contrastText: "#000",
    },

    info: {
      main: "#16aa9d",
      contrastText: "#fff",
    },
  },
};

export default theme;
